<template>
  <a-upload-dragger
    v-model:fileList="fileList"
    :show-upload-list="false"
    name="file"
    :multiple="true"
    :customRequest="e => upload(e)"
    :accept="'.xls,.xlsx'"
    :headers="headers"
    :remove="false"
  >
    <div
      v-if="fileList.length > 0"
      class="w160 h90 pa l0 t0"
      :style="
        `background: url('${fileList}') center center/ contain no-repeat;`
      "
    ></div>
    <div
      class="w160 h90 pa l0 t0"
      v-if="fileList.length === 0 || fileList === ''"
    >
      <a-button class="mb10" style="margin-top: 14px;">立即上传</a-button>
      <p class="ant-upload-hint fs12">
        或拖放上传
      </p>
    </div>
  </a-upload-dragger>
</template>
<script>
import { formRequest } from 'cupshe-axios'
import { reactive, toRefs, ref } from 'vue'
import { message, notification } from 'ant-design-vue'
import { useStore } from 'vuex'
const store = useStore()
const userInfo =
  store && store.user && store.user.userInfo ? store.user.userInfo : null
export default {
  setup() {
    const state = reactive({
      fileList: [],
      info: null,
      userInfo: userInfo,
      upload: (info = null) => {
        state.fileList = [info.file]
        state.info = info
        state.uploadHandleChange()
      },
      uploadHeaders: {
        Authorization:
          localStorage.getItem('token') || '0e044f64c5364f93a5cb83731a09b8b9'
      },
      uploadHandleChange: async () => {
        const { info, userInfo } = state
        if (info && info.file) {
          const api = `https://testtools.kapeixi.cn/upload`
          const { retCode, retInfo, erroList } = await formRequest(api, {
            file: info.file,
            userName:
              userInfo && userInfo.email ? userInfo.email : 'daoqing.cha'
          })
          if (retCode === '0000') {
            message.success('全部创建成功!')
          } else if (retCode === '1000' || retCode === '2000') {
            let erroListStr = ''
            let newErroList = [
              ...(!['', null, [], undefined].includes(erroList) &&
              erroList.length > 0
                ? erroList
                : [])
            ]
            for (let i = 0; i < newErroList.length; i++) {
              erroListStr += `
              第${newErroList[i].rowNum}行：${newErroList[i].erroInfo}；
              \n`
            }
            state.fileList = []
            // message.error(retInfo)
            notification['error']({
              message:
                retCode === '1000' ? '部分创建成功!' : '可创建issue为空!',
              duration: null,
              description: erroListStr
            })
          } else if (retCode === '3000' || retCode === '9999') {
            notification['error']({
              message:
                retCode === '3000'
                  ? '数据异常!'
                  : '导入异常，请检查模板是否正确!',
              duration: null
            })
          }
        } else {
          message.info('文件未上传！')
        }
      }
    })
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped></style>
